import { Role } from './models/role.model';

export const MIN_DATE = new Date('0001-01-01T00:00:00+00:00');
export const MAX_DATE = new Date('9999-12-31T23:59:59.9999999+00:00');
export const DEFAULT_LOCALE = 'en-US';
export const ENTITLEMENT_NEW_THRESHOLD_DAYS = 3;
export const EXPIRING_SOON_THRESHOLD_DAYS = 7;
export const SELECTABLE_ROLES = [Role.Admin, Role.Contributor];
